/*
  Page configuration for the Aurora — Sales Intelligence drill-down.

  There is no data here any more: health, sales, quarterly and incidents all come
  from the deep-dive endpoints (`aurora/overview`, `aurora/sales/*`,
  `aurora/incidents`) through `SystemIntelligenceView`. What is left is the
  handful of choices the API cannot make for us — which service to ask, what the
  page is called, and what one row of its sales figures counts.
*/

import type { SystemPageConfig } from './system-intelligence'

export const auroraPage: SystemPageConfig = {
  service: 'aurora',
  title: 'Aurora — Sales Intelligence',
  unit: 'Sales',
  // Three tiles above the scope row and none below it: response time, 30-day
  // uptime, sales today.
  salesTodayHeader: true,
}
